import React from 'react';
import usePageMetadata from '../utils/usePageMetadata';
import './About.css';

const About = () => {
  usePageMetadata({
    title: 'About The Ad Shop | Built by Publishers for Publishers',
    description:
      'Learn about The Media Shop team behind The Ad Shop, the unified analytics dashboard built to help publishers connect Google Analytics 4 and AdSense revenue insights.',
    canonicalUrl: 'https://theadshop.co/about',
    meta: [
      { property: 'og:title', content: 'About The Ad Shop | Built by Publishers for Publishers' },
      {
        property: 'og:description',
        content:
          'Meet the analytics, revenue, and automation experts empowering publishers with The Ad Shop’s unified GA4 + AdSense dashboard.',
      },
      { property: 'og:type', content: 'article' },
      { property: 'og:url', content: 'https://theadshop.co/about' },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: 'About The Ad Shop | Built by Publishers for Publishers' },
      {
        name: 'twitter:description',
        content:
          'Discover the mission and team behind The Ad Shop—the analytics platform turning publisher data into action.',
      },
    ],
    jsonLd: {
      '@context': 'https://schema.org',
      '@type': 'AboutPage',
      name: 'About The Ad Shop',
      url: 'https://theadshop.co/about',
      description:
        'The Ad Shop is created by The Media Shop to help publishers unify analytics and revenue data in one dashboard.',
      publisher: {
        '@type': 'Organization',
        name: 'The Media Shop, LLC',
        url: 'https://theadshop.co/',
      },
    },
  });

  return (
    <div className="about-page">
      <div className="about-container">
        <div className="about-header">
          <h1>About Us</h1>
        </div>

        <div className="about-content">
          <section className="about-section">
            <h2>Smarter Data for Publishers</h2>
            <p>
              At The Ad Shop, we're a team of revenue, analytics, and automation experts on a mission to help publishers make sense of their data and turn it into action.
            </p>
            <p>
              We've seen how overwhelming today's dashboards can be: endless charts, confusing metrics, and no clear path to better performance. That's why we built The Ad Shop — a simpler, smarter analytics experience designed specifically for content creators and publishers who care about growth.
            </p>
            <p>
              We bring together your site's key signals (traffic, engagement, SEO, and monetization) and translate them into insights you can actually use. Whether you run a niche blog or a growing media network, The Ad Shop helps you see what's working, what's not, and where your next opportunity lies.
            </p>
          </section>

          <section className="about-section">
            <h2>Built by People Who Get It</h2>
            <p>
              Our team comes from backgrounds in digital publishing, ad operations, and analytics engineering. We've managed ad stacks, optimized revenue streams, and built automations for some of the internet's most complex media setups — and we're bringing that expertise to everyone.
            </p>
            <p>
              We believe great tools shouldn't require a data science degree. So we've stripped away the noise, automated the heavy lifting, and built a platform that gives you clarity at a glance. From discovering underperforming pages to spotting SEO wins to tracking which content drives the most revenue, The Ad Shop surfaces the "why" behind your numbers.
            </p>
          </section>

          <section className="about-section">
            <h2>Our Vision</h2>
            <p>
              We're here to make publisher analytics fast, intuitive, and actionable. No plug-ins, no spreadsheets, no guesswork. Just meaningful data that helps you grow.
            </p>
            <p>
              The Ad Shop is built for the future of independent publishing: transparent, automated, and data-driven. If you're ready to stop chasing metrics and start making decisions that move your business forward, we're ready to help you do it.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default About;

